import { FrameData } from '../../types';
import { BeatPulse, SmoothedValue } from '../../utils/audioUtils';
import { hsl } from '../../utils/colorUtils';
import { LayerRenderer } from './LayerRenderer';

export class GradientBackgroundRenderer implements LayerRenderer {
  private beatPulse = new BeatPulse(0.96);
  private smoothHue1 = new SmoothedValue(0.03);
  private smoothHue2 = new SmoothedValue(0.02);
  private smoothBright = new SmoothedValue(0.06);

  init(): void {}

  render(
    ctx: CanvasRenderingContext2D,
    frame: FrameData,
    settings: Record<string, number>,
    width: number,
    height: number,
  ): void {
    const { bassEnergy, trebleEnergy, overallEnergy, isBeat, beatIntensity } = frame;
    const baseHue = settings.baseHue ?? 250;
    const intensity = settings.intensity ?? 1.0;
    const cx = width / 2;
    const cy = height / 2;

    this.beatPulse.update(isBeat, beatIntensity);

    const hue1 = this.smoothHue1.update(baseHue + bassEnergy * 60 - trebleEnergy * 40);
    const hue2 = this.smoothHue2.update(baseHue + 60 + trebleEnergy * 50 - bassEnergy * 30);
    const brightness = this.smoothBright.update(25 + overallEnergy * 30 * intensity);

    const maxRadius = Math.max(width, height) * 0.8;
    const breathRadius = maxRadius * (0.7 + this.beatPulse.value * 0.35);

    const gradient = ctx.createRadialGradient(cx, cy, 0, cx, cy, breathRadius);
    gradient.addColorStop(0, hsl(hue1, 70, brightness + 15));
    gradient.addColorStop(0.5, hsl((hue1 + hue2) / 2, 60, brightness));
    gradient.addColorStop(1, hsl(hue2, 50, brightness - 10));

    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, width, height);
  }

  resize(): void {}
  destroy(): void {}
}
